<template>
  <div>
    <v-form id="payment-form" ref="paymentForm" data-id="cartCheckout_paymentForm">
      <v-row no-gutters>
        <v-col v-if="error" cols="12" class="mt-3">
          <span class="error--text">Payment Error: {{ error.message }}</span>
        </v-col>
        <v-col cols="12">
          <h3 class="text-title-small font-weight-bold my-3">
            Card Details
          </h3>
        </v-col>
        <v-col cols="12">
          <v-text-field id="cardName" v-model="billingDetails.name" name="cardName" color="rgba(0,0,0,0.38)" class="card-field" placeholder="Name on card" autocomplete="cc-name" outlined :rules="[requiredRule]" dense single-line />
        </v-col>
        <v-col cols="12">
          <div class="form-row w-100 mb-1">
            <div id="cardNumber-element" />
            <div id="cardNumber-errors" class="caption red--text card-error" role="alert" />
          </div>
        </v-col>
        <v-col cols="12" sm="6" class="pr-sm-1">
          <div class="form-row w-100 mb-1">
            <div id="cardExpiry-element" />
            <div id="cardExpiry-errors" class="caption red--text card-error" role="alert" />
          </div>
        </v-col>
        <v-col cols="12" sm="6" class="pl-sm-1">
          <div class="form-row w-100 mb-1">
            <div id="cardCvc-element" />
            <div id="cardCvc-errors" class="caption red--text card-error" role="alert" />
          </div>
        </v-col>
        <div id="card-errors" class="caption red--text mx-auto" role="alert" />
        <v-col cols="12">
          <h3 class="text-title-small font-weight-bold mb-3">
            Billing Address
          </h3>
        </v-col>
        <v-col cols="12">
          <v-text-field id="billingDetailsAddress" v-model="billingDetails.address" class="card-field" label="Address Line 1" autocomplete="address-line1" outlined :rules="[requiredRule]" dense />
        </v-col>
        <v-col cols="12">
          <v-text-field id="billingDetailsAddressLineTwo" v-model="billingDetails.addressLineTwo" class="card-field" label="Address Line 2" autocomplete="address-line2" outlined dense />
        </v-col>
        <v-col cols="12">
          <v-text-field id="billingDetailsAddressSuburb" v-model="billingDetails.suburb" class="card-field" label="Suburb" autocomplete="address-level2" outlined :rules="[requiredRule]" dense />
        </v-col>
        <v-col cols="6" class="pr-1">
          <v-text-field id="billingDetailsAddressState" v-model="billingDetails.state" class="card-field" label="State" autocomplete="address-level1" outlined :rules="[requiredRule]" dense />
        </v-col>
        <v-col cols="6" class="pl-1">
          <v-text-field id="billingDetailsAddressPostcode" v-model="billingDetails.postcode" class="card-field" label="Postcode" outlined :rules="[requiredRule]" dense />
        </v-col>
        <v-col cols="12">
          <v-autocomplete id="billingDetailsAddressCountry" v-model="billingDetails.country" :items="$store.getters['countries/countrySelect']" item-text="name" item-value="name" class="card-field" label="Country" outlined :rules="[requiredRule]" dense />
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>
<script>
import axios from 'axios'

export default {
  props: {
    invoiceNumber: { type: String, default: null }
  },
  data() {
    return {
      stripe: null,
      error: null,
      cardNumber: null,
      cardExpiry: null,
      cardCvc: null,
      billingDetails: {},
      requiredRule: v => !!v || 'Field is required'
    }
  },
  mounted() {
    this.initStripe()
    this.mountStripe()
  },
  methods: {
    initStripe() {
      // Create a Stripe client.
      this.stripe = Stripe(this.$store.state.config.stripePublishable) // eslint-disable-line

      // Create an instance of Elements.
      const elements = this.stripe.elements()

      const style = {
        base: {
          color: '#32325d',
          fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
          fontSmoothing: 'antialiased',
          fontSize: '16px',
          '::placeholder': {
            color: '#aab7c4'
          }
        },
        invalid: {
          color: '#fa755a',
          iconColor: '#fa755a'
        }
      }

      this.cardNumber = elements.create('cardNumber', { placeholder: 'Card Number', style, showIcon: true })
      this.cardExpiry = elements.create('cardExpiry', { placeholder: 'Expiry', style })
      this.cardCvc = elements.create('cardCvc', { style })
    },
    makeCardFieldChangeListener(elementId) {
      return (event) => {
        const displayError = document.getElementById(elementId)
        if (event.error) {
          displayError.textContent = event.error.message
        } else {
          displayError.textContent = ''
        }
      }
    },
    mountStripe() {
      this.$nextTick(() => {
        this.cardNumber.mount('#cardNumber-element')
        this.cardExpiry.mount('#cardExpiry-element')
        this.cardCvc.mount('#cardCvc-element')

        // Handle real-time validation errors from the card Element.
        this.cardNumber.addEventListener('change', this.makeCardFieldChangeListener('cardNumber-errors'))
        this.cardExpiry.addEventListener('change', this.makeCardFieldChangeListener('cardExpiry-errors'))
        this.cardCvc.addEventListener('change', this.makeCardFieldChangeListener('cardCvc-errors'))
      })
    },
    submit() {
      if (this.$refs.paymentForm.validate()) {
        this.$emit('isLoading', true)
        const billingDetails = {
          name: this.billingDetails.name,
          address_line1: this.billingDetails.address,
          address_line2: this.billingDetails.addressLineTwo,
          address_city: this.billingDetails.suburb,
          address_state: this.billingDetails.state,
          address_zip: this.billingDetails.postcode,
          address_country: this.billingDetails.country
        }

        this.stripe.createToken(this.cardNumber, billingDetails).then(function(result) {
          if (result.error) {
          // Inform the user if there was an error.
          // const errorElement = document.getElementById('card-errors')
          // errorElement.textContent = result.error.message
            this.$emit('isLoading', false)
          } else {
            const body = { token: result.token.id, billingDetails: this.billingDetails }
            axios.post(`/invoices/${this.invoiceNumber}/pay/stripe`, body)
              .then((result) => {
                this.$emit('success', { gatewayToken: result.gatewayToken })
              })
              .catch((err) => {
                this.error = { message: err.response?.data?.message || 'Error processing payment, please try again or contact the system administrator.' }
              }).finally(() => {
                this.$emit('isLoading', false)
              })
          }
        }.bind(this))
      }
    }
  }
}
</script>

<!-- Must be regular css, sass doesn't handle deep selectors (>>>) properly -->
<style scoped>
  .card-field >>> .v-input__control > .v-input__slot {
    background-color: white !important;
  }

  .card-field >>> .v-input__control > .v-input__slot > fieldset {
    border-width: 1px !important;
    border-color: rgba(0, 0, 0, 0.38) !important;
  }

  .card-field >>> .v-input__control > .v-input__slot > .v-text-field__slot > label:not(.v-label--active) {
    color: #9BACC8 !important;
  }

  .StripeElement {
    box-sizing: border-box;

    height: 40px;

    padding: 10px 12px;

    border: 1px solid;
    border-radius: 4px;
    border-color: rgb(0, 0, 0, 0.3);

    box-shadow: 0 1px 3px 0 #e6ebf1;
    -webkit-transition: box-shadow 150ms ease;
    transition: box-shadow 150ms ease;
    background-color: white;
  }

  .StripeElement--focus {
    box-shadow: 0 1px 3px 0 #cfd7df;
  }

  .StripeElement--invalid {
    border-color: #fa755a;
  }

  .StripeElement--webkit-autofill {
    background-color: #fefde5 !important;
  }

  .card-error {
    min-height: 20px;
  }
</style>
